export default __webpack_public_path__ + "static/motu3-e661bf6b3e9ae8dca3bf9cedcb9a1371.jpg";